import React, {useCallback, useEffect, useState} from "react";
import {listAdmins} from "../api";
import type {AdminUserItem} from "../api";
import {useAuth} from "../auth";
import {ErrorBanner} from "./ErrorBanner";
import {SecondFactorControl} from "./SecondFactorControl";

/** Админы и их код из приложения. Код админу включает другой админ. */
export function AdminSecondFactorSection(): JSX.Element {
    const {token} = useAuth();
    const [admins, setAdmins] = useState<AdminUserItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<unknown>(null);

    const load = useCallback((): void => {
        setLoading(true);
        setError(null);
        listAdmins(token)
            .then((resp) => setAdmins(resp.items))
            .catch(setError)
            .finally(() => setLoading(false));
    }, [token]);

    useEffect(load, [load]);

    return (
        <section className="admin-list-section">
            <div className="section-header">
                <div>
                    <h3>Администраторы</h3>
                    <span>Вход с 2FA. Включение 2FA закрывает открытые сессии.</span>
                </div>
            </div>
            <ErrorBanner error={error} title="Список администраторов не загружен" />
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Login</th>
                            <th>Status</th>
                            <th>2FA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={3} className="empty-state">Загрузка…</td>
                            </tr>
                        ) : admins.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="empty-state">Администраторы не найдены.</td>
                            </tr>
                        ) : (
                            admins.map((admin) => (
                                <tr key={admin.userId}>
                                    <td><strong>{admin.login}</strong></td>
                                    <td>
                                        <span className={`status-dot ${admin.isActive ? "dot-active" : "dot-inactive"}`} />
                                        {admin.isActive ? "Active" : "Inactive"}
                                    </td>
                                    <td>
                                        <SecondFactorControl
                                            userId={admin.userId}
                                            login={admin.login}
                                            status={admin.secondFactor}
                                            onChanged={(secondFactor) =>
                                                setAdmins((items) =>
                                                    items.map((item) =>
                                                        item.userId === admin.userId ? {...item, secondFactor} : item,
                                                    ),
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
